import ReleaseSummary from "./ReleaseSummary";

export default ReleaseSummary;
